import React, { useEffect, useState } from 'react';

function VerifyEmail() {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const email = params.get('email');
    if (!token || !email) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }
    fetch(`/api/verify-email?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStatus('success');
          setMessage('Email verified! You can now log in.');
        } else {
          setStatus('error');
          setMessage(data.error || 'Verification failed.');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Network error.');
      });
  }, []);

  return (
    <div style={{ maxWidth: 400, margin: '60px auto', padding: 24, textAlign: 'center' }}>
      <h2>Email Verification</h2>
      {status === 'verifying' && <p>Verifying...</p>}
      {status !== 'verifying' && <p style={{ color: status === 'success' ? '#1a7f37' : '#d32f2f', fontWeight: 500 }}>{message}</p>}
      {status === 'success' && <a href="/" style={{ color: '#0070f3', textDecoration: 'underline' }}>Go to Login</a>}
    </div>
  );
}

export default VerifyEmail;
